(function($) {

	"use strict";

/** --------------------------------------------------
 * 
 *   elements - NUMBER SPINNERS
 *
 *   TABLE OF CONTENTS
 *   document ready
 *   drupal behavior
 *
 *  -------------------------------------------------- */




/** --------------------------------------------------
    #document ready
    -------------------------------------------------- */

	$(document).ready(function() {

		/* example - call numberspinner */
		/* **************************** */

		// $('.path-product .table-add-to-cart-form .form-number').each(function(index, element) {
		// 	new duo.NumberSpinner({
		// 		inputElement: $(element),
		// 		onValueIsOK: function(currentNumber) {
		// 			let $maxQuantityBlock = $(element).parents('.item.form-wrapper').find('.max-quantity');
		// 			$maxQuantityBlock.removeClass('visible');
		// 		},
		// 		onValueTooHigh: function(maxNumber) {
		// 			let $maxQuantityBlock = $(element).parents('.item.form-wrapper').find('.max-quantity');
		// 			$maxQuantityBlock.addClass('visible');
		// 		},
		// 		checkForZero: true
		// 	});
		// });

		// -> product detail:
		$('.path-product .cart-wrapper .field--name-quantity .form-number').each(function(index, element) {
			new duo.NumberSpinner({
				inputElement: $(element)
			});
		});
		// -> cart:
		$('.path-cart .cart-form .form-number').each(function(index, element) {
			new duo.NumberSpinner({
				inputElement: $(element)
			});
		});
		// -> product sm teaser:
		$('.commerce-product--type-default.commerce-product--view-mode-sm .form-number').each(function(index, element) {
			new duo.NumberSpinner({
				inputElement: $(element)
			});
		});

	});




/** --------------------------------------------------
    #drupal behavior
    -------------------------------------------------- */

	Drupal.behaviors.numberSpinners = {
		attach: function (context, settings) {

			/* product teasers */
			/* *************** */

			$('.commerce-product--view-mode-teaser .form-number').each(function(index, element) {
				new duo.NumberSpinner({
					inputElement: $(element)
				});
			});

			/* shopping cart - gift modal */
			/* ************************** */

			$('.path-cart .gift-form-wrapper .form-number').each(function(index, element) {
				new duo.NumberSpinner({
					inputElement: $(element),
					checkForZero: true
				});
			});

		}
	};




})(jQuery);
